import * as React from 'react';
import useStyles from './Auth0SelectButton.styles';
import Typography from '../Typography/Typography';
import { Icon } from '../Icon';

export interface IAuth0SelectButtonProps {
  buttonText: JSX.Element;
  onClick: () => void;
}

const Auth0SelectButton: React.FC<IAuth0SelectButtonProps> = ({
  buttonText,
  onClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} onClick={onClick}>
      <Typography className={classes.buttonText}>{buttonText}</Typography>
      <div className={classes.chevron}>
        <Icon type={'chevronRight'} />
      </div>
    </div>
  );
};

export default Auth0SelectButton;
